/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Headline_Document_DeletedInputs */

const en_case_history_headline_document_deleted = /** @type {(inputs: Case_History_Headline_Document_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File deleted`)
};

const pt_br2_case_history_headline_document_deleted = /** @type {(inputs: Case_History_Headline_Document_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo excluído`)
};

/**
* | output |
* | --- |
* | "File deleted" |
*
* @param {Case_History_Headline_Document_DeletedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_headline_document_deleted = /** @type {((inputs?: Case_History_Headline_Document_DeletedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Headline_Document_DeletedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_headline_document_deleted(inputs)
	return pt_br2_case_history_headline_document_deleted(inputs)
});